package com.eladfinish.bible.contest.analytics

import com.eladfinish.bible.contest.constants.BooleanConstants
import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.russhwolf.settings.Settings

/** The user's anonymous usage statistics preference; gates every analytics event, not only ad events. */
fun Settings.usageStatsEnabled(): Boolean = getBoolean(
    SharedPrefsConstants.KEY_ENABLE_ANONYMOUS_USAGE_STATS, BooleanConstants.ENABLE_ANONYMOUS_USAGE_STATS,
)
